import axios from 'axios';
import { getConfig } from 'redux/actions/configActions';
import {
  apiRecoverPassword,
  apiConfirmNewPassword,
  apiUpdateUser,
  apiVerifyEmail,
  apiUpdateEmail,
  apiUpdatePassword,
  apiManagedServicesUpdatePassword,
} from 'constants/apiRouting';
import { createActionType } from 'utils/redux';
import { segmentIdentifyUser } from 'utils/analytics';
import {
  APP_LOGIN,
  PERSONAL_ACCOUNT_UPDATE,
  PERSONAL_ACCOUNT_EMAIL_UPDATE,
  PERSONAL_ACCOUNT_PASSWORD_UPDATE,
} from 'constants/analytics';
import { handleErrors } from '../../utils/api';
import { API_CONFIG } from '../../constants/config';
import { analyticsTrack } from '../../utils/analytics';

// object
export const GET_USER_PENDING = 'GET_USER_PENDING';
export const GET_USER_FAIL = 'GET_USER_FAIL';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const RECOVER_PASSWORD = createActionType('RECOVER_PASSWORD');
export const CONFIRM_NEW_PASSWORD = createActionType('CONFIRM_NEW_PASSWORD');
// objects
export const GET_USERS_PENDING = 'GET_USERS_PENDING';
export const GET_USERS_FAIL = 'GET_USERS_FAIL';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const UPDATE_USER = createActionType('UPDATE_USER');
export const VERIFY_EMAIL = createActionType('VERIFY_EMAIL');
export const UPDATE_EMAIL = createActionType('UPDATE_EMAIL');
export const UPDATE_PASSWORD = createActionType('UPDATE_PASSWORD');
export const MANAGED_SERVICES_UPDATE_PASSWORD = createActionType('MANAGED_SERVICES_UPDATE_PASSWORD');


export const getUser = () => async (dispatch) => {
  dispatch({
    type: GET_USER_PENDING,
    payload: {},
  });
  try {
    const response = await axios.get(`${API_CONFIG.API_BASE}api-auth/user/`, {
      withCredentials: true,
    });
    segmentIdentifyUser(response.data);
    dispatch({
      type: GET_USER_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const login = (params = {}) => async (dispatch) => {
  try {
    await axios.post(`${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}user/login/`, {
      email: params.email,
      password: params.password,
    }, {
      withCredentials: true,
    });

    dispatch({ type: GET_USER_PENDING, payload: {} });
    const response = await axios.get(`${API_CONFIG.API_BASE}api-auth/user/`, {
      withCredentials: true,
    });

    segmentIdentifyUser(response.data);

    analyticsTrack(APP_LOGIN, {
      email: params.email,
    }, true);

    dispatch({
      type: GET_USER_SUCCESS,
      payload: response.data,
    });

    dispatch(getConfig());
  } catch (error) {
    handleErrors(error, dispatch);
  }
};

export const googleLogin = params => async (dispatch) => {
  try {
    await axios.post(
      `${API_CONFIG.API_BASE}v1/users/google/login/`,
      params,
      { withCredentials: true },
    );

    dispatch({ type: GET_USER_PENDING, payload: {} });
    const response = await axios.get(`${API_CONFIG.API_BASE}api-auth/user/`, { withCredentials: true });
    segmentIdentifyUser(response.data);
    analyticsTrack(APP_LOGIN, { email: params.email }, true);
    dispatch({ type: GET_USER_SUCCESS, payload: response.data });
    dispatch(getConfig());
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const logout = () => async (dispatch) => {
  try {
    await axios.get(`${API_CONFIG.API_BASE}api-auth/logout/`, {
      withCredentials: true,
    });
    dispatch({
      type: LOGOUT_USER_SUCCESS,
      payload: {},
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const recoverPassword = params => async (dispatch) => {
  dispatch({
    type: RECOVER_PASSWORD.name,
    payload: axios.post(
      apiRecoverPassword(),
      params,
    ).catch(error => handleErrors(error, dispatch)),
  });
};

export const confirmNewPassword = params => async (dispatch) => {
  const { uid, token } = params;
  await dispatch({
    type: CONFIRM_NEW_PASSWORD.name,
    payload: axios.post(
      apiConfirmNewPassword(uid, token),
      params, { withCredentials: true },
    ).catch(error => handleErrors(error, dispatch)),
  });
};


export const getUsers = (params = { search: null, groups__name: null }) => async (dispatch) => {
  dispatch({
    type: GET_USERS_PENDING,
    payload: {},
  });
  try {
    const response = await axios.get(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}users/`,
      { params, withCredentials: true },
    );
    dispatch({
      type: GET_USERS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};

export const updateUser = params => async (dispatch) => {
  analyticsTrack(PERSONAL_ACCOUNT_UPDATE, params, true);
  return dispatch({
    type: UPDATE_USER.name,
    payload: axios.patch(
      apiUpdateUser(),
      params,
      { withCredentials: true },
    ).catch(error => handleErrors(error, dispatch)),
  });
};

export const updateEmail = params => async (dispatch) => {
  analyticsTrack(PERSONAL_ACCOUNT_EMAIL_UPDATE, { email: params.email }, true);
  return dispatch({
    type: UPDATE_EMAIL.name,
    payload: axios.patch(
      apiUpdateEmail(),
      params,
      { withCredentials: true },
    ).catch(error => handleErrors(error, dispatch)),
  });
};

export const verifyEmail = params => async (dispatch) => {
  dispatch({
    type: VERIFY_EMAIL.name,
    payload: axios.post(
      apiVerifyEmail(),
      params,
      { withCredentials: true },
    ).catch(error => handleErrors(error, dispatch)),
  });
};

export const updatePassword = params => async (dispatch) => {
  analyticsTrack(PERSONAL_ACCOUNT_PASSWORD_UPDATE, {}, true);
  return dispatch({
    type: UPDATE_PASSWORD.name,
    payload: axios.post(
      apiUpdatePassword(),
      params,
      { withCredentials: true },
    ).catch(error => handleErrors(error, dispatch)),
  });
};

export const changeManagedServicesUserPassword = params => async (dispatch) => {
  try {
    await axios.put(
      apiManagedServicesUpdatePassword(),
      params,
      { withCredentials: true },
    );

    await axios.post(`${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}user/login/`, {
      email: params.email,
      password: params.password,
    }, {
      withCredentials: true,
    });

    const response = await axios.get(`${API_CONFIG.API_BASE}api-auth/user/`, {
      withCredentials: true,
    });

    dispatch({
      type: MANAGED_SERVICES_UPDATE_PASSWORD.name,
      payload: response,
    });
    segmentIdentifyUser(response.data);

    analyticsTrack(APP_LOGIN, {
      email: params.email,
    }, true);

    dispatch({
      type: GET_USER_SUCCESS,
      payload: response.data,
    });

    dispatch(await getConfig());
  } catch (error) {
    handleErrors(error, dispatch);
  }
};
